<ng-container *ngIf="message">
  <div
    #messageBubble
    class="agent-message-box agent-message-bubble"
    @rotateInDownLeft
    [attr.id]="messageId"
    [attr.tabindex]="focusable ? '-1' : null"
  >
    <div
      class="text-block chat-text-box agent-message-text"
      [ngClass]="opacityTransition ? 'opacity-transition' : ''"
      [innerHTML]="message"
    ></div>
  </div>
</ng-container>
